export default "__VITE_ASSET__Cbkdp5uu__"